import { AgencyConstants } from 'features/Agency/agencyHelper';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import { KTBSDropdownAlignments } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import DashboardChartCard from 'general/components/quybka/Cards/DashboardChartCard';
import BarChart from 'general/components/quybka/Charts/BarChart';
import DoughnutChartJS from 'general/components/quybka/Charts/DoughnutChartJS';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

MaintainerDashboardView.propTypes = {};

function MaintainerDashboardView(props) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const isAdmin = user.role === 'ADMIN';
    const [loadingDailyData, setLoadingDailyData] = useState(false);
    const [loadingRealtimeData, setLoadingRealtimeData] = useState(false);
    // thong tin tru sac
    const [chargePointStatistic, setChargePointStatistic] = useState({
        total: 0,
        charging: 0,
        connected: 0,
    });
    // thong tin he thong
    const [systemStatistic, setSystemStatistic] = useState({
        totalEnergy: 0, // san luong dien trong ngay
        totalPower: 0, // cong suat tuc thi cua he thong
        totalTransactions: 0, // tong so phien sac trong ngay
        totalChargeDuration: 0, // tong thoi gian sac trong ngay
    });
    // bieu do
    const [chartData, setChartData] = useState({});
    const [chartFilter, setChartFilter] = useState({
        from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
        to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        selectedValue: dateFilter.baMuoiNgayGanNhat,
    });

    useEffect(() => {
        ChargeHelper.API.Dashboard.requestGetDailyData({
            from: chartFilter.from,
            to: chartFilter.to,
        }).then((res) => {
            setChartData(res ?? {});
        });
    }, [chartFilter]);
    useEffect(() => {
        requestGetRealtimeData();
        requestGetSystemLogData();
        requestGetAgencyStatistic();
        requestGetRevenueSummary();
        const timer = setInterval(() => {
            requestGetRealtimeData();
            requestGetSystemLogData();
        }, 5000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        setEnergyFilter({ ...chartFilter, energyType: energyType });
        setTransactionFilter({ ...chartFilter, transactionType: transactionType });
        setEnergyRevenueFilter({ ...chartFilter, energyRevenueType: energyRevenueType });
        setRevenueFilter({ ...chartFilter, revenueType: revenueType });
    }, [chartFilter])

    const processVehicleData = (data) => {
        if (!data) return;
        const transactionCount = {
            CAR: [],
            BIKE: []
        };
        const totalRevenue = {
            CAR: [],
            BIKE: []
        };
        const totalEnergy = {
            CAR: [],
            BIKE: []
        };

        data?.forEach(day => {
            const date = day.date;

            const carData = day.vehicleTypes.find(v => v.vehicleType === "CAR");
            const bikeData = day.vehicleTypes.find(v => v.vehicleType === "BIKE");

            transactionCount.CAR.push({
                date: date,
                transactions: carData.transactionCount || 0
            });
            transactionCount.BIKE.push({
                date: date,
                transactions: bikeData.transactionCount || 0
            });

            totalRevenue.CAR.push({
                date: date,
                amount: carData.totalRevenue || 0
            });
            totalRevenue.BIKE.push({
                date: date,
                amount: bikeData.totalRevenue || 0
            });

            totalEnergy.CAR.push({
                date: date,
                energy: carData.totalEnergy || 0
            });
            totalEnergy.BIKE.push({
                date: date,
                energy: bikeData.totalEnergy || 0
            });
        });

        return {
            transactionCount,
            totalRevenue,
            totalEnergy
        };
    }

    const chartDataByVehicle = useMemo(() => {
        return processVehicleData(chartData?.dailyByVehicleType);
    }, [chartData])

    const mergeDataByDate = (dataByCar = [], dataByBike = [], dataName) => {
        const allDates = Array.from(
            new Set([...dataByCar.map(item => item.date), ...dataByBike.map(item => item.date)])
        );

        return allDates.map(date => {
            const carAmount = dataByCar.find(item => item.date === date)?.[dataName] || 0;
            const bikeAmount = dataByBike.find(item => item.date === date)?.[dataName] || 0;

            return { date, [dataName]: carAmount + bikeAmount };
        }).sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const getDataByType = (type, vehicleType, chartData, chartDataByVehicle) => {
        const typeMap = {
            transaction: {
                '': mergeDataByDate(
                    chartDataByVehicle?.transactionCount?.CAR,
                    chartDataByVehicle?.transactionCount?.BIKE,
                    'transactions'
                ),
                BIKE: chartDataByVehicle?.transactionCount?.BIKE,
                CAR: chartDataByVehicle?.transactionCount?.CAR
            },
            energy: {
                '': mergeDataByDate(
                    chartDataByVehicle?.totalEnergy?.CAR,
                    chartDataByVehicle?.totalEnergy?.BIKE,
                    'energy'
                ),
                BIKE: chartDataByVehicle?.totalEnergy?.BIKE,
                CAR: chartDataByVehicle?.totalEnergy?.CAR
            },
            revenue: {
                '': mergeDataByDate(
                    chartDataByVehicle?.totalRevenue?.CAR,
                    chartDataByVehicle?.totalRevenue?.BIKE,
                    'amount'
                ),
                BIKE: chartDataByVehicle?.totalRevenue?.BIKE,
                CAR: chartDataByVehicle?.totalRevenue?.CAR
            }
        };

        return typeMap[type]?.[vehicleType] || null;
    };

    const [energyType, setEnergyType] = useState('');
    const [energyFilter, setEnergyFilter] = useState({ ...chartFilter, energyType: energyType });
    // dien sac theo ngay
    const chartEnergyByDateEl = useMemo(() => {
        const energyByDate = getDataByType('energy', energyType, chartData, chartDataByVehicle);
        if (!energyByDate) return;
        let labels = energyByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = energyByDate?.map((item) => ((item.energy ?? 0) / 1000).toFixed(3));
        if (energyByDate?.length > 31) {
            const groupedData = _.groupBy(energyByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.energy, 0);
                return (total / 1000).toFixed(3);
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê điện sạc"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)?.toFixed(3)) +
                    ' kWh'
                }
                valueColor="rgba(41, 132, 238, 1)"
                actionEl={
                    <DropdownFilterTable
                        id="energyType"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại điện sạc"
                                    filterKey="energyType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.vehicleTypeOptions,
                                    ]}
                                    selectedValue={energyFilter.energyType}
                                    handleChange={(value) => {
                                        setEnergyFilter({ ...energyFilter, energyType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={energyFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setEnergyFilter({
                                            ...energyFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setEnergyFilter({ ...updateChartFilter, energyType: '' });
                            setEnergyType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { energyType, ...dateFilter } = energyFilter;
                            setChartFilter(dateFilter);
                            setEnergyType(energyType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, energyType },
                            false
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Điện sạc"
                        unit="kWh"
                        labels={labels}
                        data={data}
                        color="rgba(41, 132, 238, 0.4)"
                        hoverColor="rgba(41, 132, 238, 1)"
                    />
                }
            />
        );
    }, [chartDataByVehicle, chartData, chartFilter, energyFilter, energyType]);

    // doanh thu theo ngay
    const aggregateRevenueByDate = (investor, group, chargePoint) => {
        const allDates = chartData.revenueByDate?.map(item => item.date);

        const result = allDates?.map(date => {
            const investorItem = investor?.find(item => item.date === date);
            const investorAmount = investorItem ? investorItem.kpiValue : 0;
            const groupItem = group?.find(item => item.date === date);
            const groupAmount = groupItem ? groupItem.kpiValue : 0;
            const chargePointItem = chargePoint?.find(item => item.date === date);
            const chargePointAmount = chargePointItem ? chargePointItem.kpiValue : 0;

            const totalAmount = investorAmount + groupAmount + chargePointAmount;

            return { date, amount: totalAmount };
        });

        return result;
    }

    const getRevenueData = (type) => {
        switch (type) {
            case ChargeConstants.DashboardRevenueType.GROUP:
                return aggregateRevenueByDate(null, chartData.groupSaleByDate, null);
            case ChargeConstants.DashboardRevenueType.INVESTOR:
                return aggregateRevenueByDate(chartData.investorSaleByDate, null, null);
            case ChargeConstants.DashboardRevenueType.CHARGEPOINT:
                return aggregateRevenueByDate(null, null, chartData.chargePointSaleByDate);
            default:
                return aggregateRevenueByDate(chartData.investorSaleByDate, chartData.groupSaleByDate, chartData.chargePointSaleByDate);
        }
    }

    const [energyRevenueType, setEnergyRevenueType] = useState('');
    const [energyRevenueFilter, setEnergyRevenueFilter] = useState({ ...chartFilter, energyRevenueType: energyRevenueType });
    const chartEnergyRevenueByDateEl = useMemo(() => {
        const energyRevenueByDate = getDataByType('revenue', energyRevenueType, chartData, chartDataByVehicle);
        if (!energyRevenueByDate) return;
        let labels = energyRevenueByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = energyRevenueByDate?.map((item) => item.amount ?? 0);

        if (energyRevenueByDate?.length > 31) {
            const groupedData = _.groupBy(energyRevenueByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê doanh thu bán điện"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' VNĐ'
                }
                valueColor="#30BDA8"
                actionEl={
                    <DropdownFilterTable
                        id="energyRevenueType"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại doanh thu"
                                    filterKey="energyRevenueType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.vehicleTypeOptions,
                                    ]}
                                    selectedValue={energyRevenueFilter.energyRevenueType}
                                    handleChange={(value) => {
                                        setEnergyRevenueFilter({ ...energyRevenueFilter, energyRevenueType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={energyRevenueFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setEnergyRevenueFilter({
                                            ...energyRevenueFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setEnergyRevenueFilter({ ...updateChartFilter, energyRevenueType: '' });
                            setEnergyRevenueType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { energyRevenueType, ...dateFilter } = energyRevenueFilter;
                            setChartFilter(dateFilter);
                            setEnergyRevenueType(energyRevenueType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, energyRevenueType },
                            false
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Doanh thu"
                        unit="VNĐ"
                        labels={labels}
                        data={data}
                        color="#30BDA84D"
                        hoverColor="#30BDA8"
                        showLine={true}
                    />
                }
            />
        );
    }, [chartDataByVehicle, chartData, chartFilter, energyRevenueFilter, energyRevenueType]);


    const [revenueType, setRevenueType] = useState('');
    const [revenueFilter, setRevenueFilter] = useState({ ...chartFilter, revenueType: revenueType });
    const chartRevenueByDateEl = useMemo(() => {
        const revenueByDate = getRevenueData(revenueType) ?? [];
        let labels = revenueByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = revenueByDate?.map((item) => item.amount ?? 0);

        if (revenueByDate?.length > 31) {
            const groupedData = _.groupBy(revenueByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.amount, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Doanh thu bán hàng"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' VNĐ'
                }
                valueColor="rgba(48, 189, 111, 1)"
                actionEl={
                    <DropdownFilterTable
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại doanh thu"
                                    filterKey="revenueType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.dashboardRevenueTypeOptions,
                                    ]}
                                    selectedValue={revenueFilter.revenueType}
                                    handleChange={(value) => {
                                        setRevenueFilter({ ...revenueFilter, revenueType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={revenueFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setRevenueFilter({
                                            ...revenueFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setRevenueFilter({ ...updateChartFilter, revenueType: '' });
                            setRevenueType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { revenueType, ...dateFilter } = revenueFilter;
                            setChartFilter(dateFilter);
                            setRevenueType(revenueType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, revenueType },
                            false
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Doanh thu"
                        unit="VNĐ"
                        labels={labels}
                        data={data}
                        color="rgba(48, 189, 111, 0.4)"
                        hoverColor="rgba(48, 189, 111, 1)"
                        showLine={true}
                    />
                }
            />
        );
    }, [chartData, chartFilter, revenueFilter, revenueType]);

    // phien sac theo ngay
    const [transactionType, setTransactionType] = useState('');
    const [transactionFilter, setTransactionFilter] = useState({ ...chartFilter, transactionType: transactionType });
    const chartTransactionByDateEl = useMemo(() => {
        const transactionByDate = getDataByType('transaction', transactionType, chartData, chartDataByVehicle);
        if (!transactionByDate) return;
        let labels = transactionByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = transactionByDate?.map((item) => item.transactions ?? 0);

        if (transactionByDate?.length > 31) {
            const groupedData = _.groupBy(transactionByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.transactions, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê phiên sạc"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' phiên sạc'
                }
                valueColor="rgba(88, 86, 214, 1)"
                actionEl={
                    <DropdownFilterTable
                        id="transactionType"
                        isLightButton={true}
                        toggleElementBorderRadius={10}
                        filterComponent={[
                            <div className="col-12 p-0">
                                <KTDropdownFilter
                                    label="Loại phiên sạc"
                                    filterKey="transactionType"
                                    options={[
                                        { name: 'Tất cả', value: '' },
                                        ...ChargeHelper.Data.vehicleTypeOptions,
                                    ]}
                                    selectedValue={transactionFilter.transactionType}
                                    handleChange={(value) => {
                                        setTransactionFilter({ ...transactionFilter, transactionType: value });
                                    }}
                                />
                            </div>,
                            <div className="col-12 p-0">
                                <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                    Khoảng thời gian thống kê
                                </label>
                                <CustomDateRangePicker
                                    alignRight={true}
                                    toggleFontWeight="600"
                                    toggleElementBorderRadius={5}
                                    initialValue={transactionFilter.selectedValue}
                                    onPressSave={(selectedValue, startDate, endDate) => {
                                        setTransactionFilter({
                                            ...transactionFilter,
                                            from: startDate,
                                            to: endDate,
                                            selectedValue: selectedValue,
                                        });
                                    }}
                                />
                            </div>
                        ]}
                        resetDefaultTable={() => {
                            const updateChartFilter = {
                                ...chartFilter,
                                from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
                                to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
                                selectedValue: dateFilter.baMuoiNgayGanNhat,
                            };
                            setTransactionFilter({ ...updateChartFilter, transactionType: '' });
                            setTransactionType('');
                            setChartFilter(updateChartFilter);
                        }}
                        saveFilter={() => {
                            const { transactionType, ...dateFilter } = transactionFilter;
                            setChartFilter(dateFilter);
                            setTransactionType(transactionType);
                        }}
                        isDefaultFilter={Utils.checkDefaultFilter(
                            ['selectedValue', 'from', 'to'],
                            { ...chartFilter, transactionType },
                            false
                        )}
                    />
                }
                chartEl={
                    <BarChart
                        title="Phiên sạc"
                        unit="phiên sạc"
                        labels={labels}
                        data={data}
                        color="rgba(88, 86, 214, 0.4)"
                        hoverColor="rgba(88, 86, 214, 1)"
                    />
                }
            />
        );
    }, [chartDataByVehicle, chartData, chartFilter, transactionFilter, transactionType]);
    // khach hang nap tien theo ngay
    const chartTopupByDateEl = useMemo(() => {
        const topupCountByDate = chartData?.topupCountByDate ?? [];
        let labels = topupCountByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = topupCountByDate?.map((item) => item.topupCount ?? 0);

        if (topupCountByDate?.length > 31) {
            const groupedData = _.groupBy(topupCountByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.topupCount, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê khách hàng nạp tiền"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' giao dịch'
                }
                valueColor="#FF9500"
                actionEl={
                    <CustomDateRangePicker
                        alignRight={true}
                        toggleFontWeight="600"
                        toggleElementBorderRadius={10}
                        initialValue={chartFilter.selectedValue}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setChartFilter({
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            });
                        }}
                    />
                }
                chartEl={
                    <BarChart
                        title="Giao dịch"
                        unit="giao dịch"
                        labels={labels}
                        data={data}
                        color="#FF95004D"
                        hoverColor="#FF9500"
                    />
                }
            />
        );
    }, [chartData, chartFilter]);
    // khach hang theo ngay
    const chartActiveUsersByDateEl = useMemo(() => {
        const activeUsersByDate = chartData?.activeUsersByDate ?? [];
        let labels = activeUsersByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = activeUsersByDate?.map((item) => item.activeUsers ?? 0);

        if (activeUsersByDate?.length > 31) {
            const groupedData = _.groupBy(activeUsersByDate, (item) =>
                moment(item.date).format('MM/YYYY')
            );
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.activeUsers, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê khách hàng"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' khách hàng'
                }
                valueColor="rgba(253, 112, 139, 1)"
                actionEl={
                    <CustomDateRangePicker
                        alignRight={true}
                        toggleFontWeight="600"
                        toggleElementBorderRadius={10}
                        initialValue={chartFilter.selectedValue}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setChartFilter({
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            });
                        }}
                    />
                }
                chartEl={
                    <BarChart
                        title="Khách hàng"
                        unit="khách hàng"
                        labels={labels}
                        data={data}
                        color="rgba(253, 112, 139, 0.4)"
                        hoverColor="rgba(253, 112, 139, 1)"
                    />
                }
            />
        );
    }, [chartData, chartFilter]);
    // khach hang moi theo ngay
    const chartNewUsersByDateEl = useMemo(() => {
        const newUsersByDate = chartData?.newUsersByDate ?? [];
        let labels = newUsersByDate?.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
        let data = newUsersByDate?.map((item) => item.newUsers ?? 0);

        if (newUsersByDate?.length > 31) {
            const groupedData = _.groupBy(newUsersByDate, (item) => moment(item.date).format('MM/YYYY'));
            labels = Object.keys(groupedData);
            data = labels?.map((label) => {
                const total = groupedData[label]?.reduce((sum, item) => sum + item.newUsers, 0);
                return total;
            });
        }

        return (
            <DashboardChartCard
                title="Thống kê khách hàng"
                name="Tổng"
                value={
                    Utils.formatNumber(data?.reduce((sum, item) => _.toNumber(sum) + _.toNumber(item), 0)) +
                    ' khách hàng'
                }
                valueColor="rgba(253, 112, 139, 1)"
                actionEl={
                    <CustomDateRangePicker
                        alignRight={true}
                        toggleFontWeight="600"
                        toggleElementBorderRadius={10}
                        initialValue={chartFilter.selectedValue}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setChartFilter({
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            });
                        }}
                    />
                }
                chartEl={
                    <BarChart
                        title="Khách hàng mới"
                        unit="khách hàng"
                        labels={labels}
                        data={data}
                        color="rgba(253, 112, 139, 0.4)"
                        hoverColor="rgba(253, 112, 139, 1)"
                    />
                }
            />
        );
    }, [chartData, chartFilter]);
    // thong bao he thong
    const [systemLogList, setSystemLogList] = useState([]);
    const [totalSystemLog, setTotalSystemLog] = useState(0);
    // danh sach tru sac
    const [chargePointSummary, setChargePointSummary] = useState({});
    // thong ke tai khoan
    const [agencyStatistic, setAgencyStatistic] = useState({});
    // thong ke doanh thu
    const [revenueSummary, setRevenueSummary] = useState({});
    // filter
    const [selectedChargeStation, setSelectedChargeStation] = useState(null);
    useEffect(() => {
        let params = {};
        if (Utils.isValid(selectedChargeStation?.id)) {
            params.stationId = selectedChargeStation?.id;
        }
        ChargeHelper.API.Dashboard.requestGetPointSummary(params).then((res) => {
            setChargePointSummary(res ?? {});
        });
    }, [selectedChargeStation]);

    const filterChargeStationEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="station_filter"
                name="station_filter"
                toggleElement={UIHelper.buildWhiteButton(
                    <div className="d-flex align-items-center gap-2">
                        <span>
                            {_.truncate(selectedChargeStation?.name ?? 'Tất cả trạm', {
                                length: 20,
                                separator: '...',
                            })}
                        </span>{' '}
                        <i className="fa-solid fa-caret-down" />
                    </div>,
                    null,
                    <div className="position-relative">
                        <i className="fa-regular fa-filter" style={{ color: AppColors.gray[700] }} />
                        {Utils.isValid(selectedChargeStation?.id) && (
                            <i
                                className="position-absolute fa-solid fa-circle"
                                style={{
                                    color: 'orange',
                                    top: '-2px',
                                    right: '-4px',
                                    fontSize: '7px',
                                }}
                            />
                        )}
                    </div>,
                    false,
                    false,
                    10
                )}
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                subTitleType="address"
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeStationList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        let values = data.chargeStations?.map((station) => ({
                            id: station?.stationId,
                            name: station?.name,
                            item: station,
                            address: ChargeHelper.Utils.getChargeStationFullAddress(station),
                        }));
                        if (!Utils.isValid(item?.page) || _.toNumber(item?.page) === 0) {
                            values = [
                                {
                                    id: null,
                                    name: 'Tất cả trạm',
                                    item: null,
                                    address: '',
                                },
                            ].concat(values);
                        }
                        return {
                            values: values,
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-300px"
                alignment={KTBSDropdownAlignments.end}
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
            />
        );
    }, [selectedChargeStation]);

    // MARK: ---- METHODS ----
    const requestGetRevenueSummary = useCallback(() => {
        ChargeHelper.API.Dashboard.requestGetRevenueSummary({ month: moment().format('YYYY-MM') }).then(
            (res) => {
                setRevenueSummary(res ?? {});
            }
        );
    }, []);
    const requestGetAgencyStatistic = useCallback(() => {
        ChargeHelper.API.Dashboard.requestGetAgencyStatistics({}).then((res) => {
            setAgencyStatistic(res ?? {});
        });
    }, []);

    const requestGetSystemLogData = useCallback(() => {
        ChargeHelper.API.SystemLog.requestGetSystemLogList({ page: 0, limit: 10 })
            .then((response) => {
                setSystemLogList(response?.messages);
                setTotalSystemLog(response?.total);
            })
            .finally(() => { });
    }, []);

    const requestGetRealtimeData = useCallback(() => {
        ChargeHelper.API.Dashboard.requestGetRealtimeData().then((res) => {
            setChargePointStatistic({
                total: res?.totalChargePoint ?? 0,
                charging: res?.chargingChargePoint ?? 0,
                connected: res?.connectedChargePoint ?? 0,
            });
            setSystemStatistic({
                totalEnergy: res?.totalEnergy ?? 0,
                totalPower: res?.totalPower ?? 0,
                totalTransactions: res?.totalTransactions ?? 0,
                totalChargeDuration: res?.totalChargeDuration ?? 0,
            });
        });
    }, []);

    return (
        <div className="mt-4" style={{ minHeight: '1200px' }}>
            {/* header */}
            <div className="row m-0 p-0 px-2">
                <div className="col-lg-6 mb-4 px-2">
                    {UIHelper.buildCard(
                        <div>
                            <div
                                className="d-flex flex-column p-4"
                                style={{
                                    borderBottom: `1px solid ${AppColors.gray[200]}`,
                                }}
                            >
                                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                                    {user?.fullname}
                                </span>
                                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                                    {ChargeHelper.Utils.getUserRoleName(user?.role).toUpperCase()}
                                </span>
                            </div>
                            <div className="d-flex flex-column gap-3 pt-2 pb-6">
                                <div className="px-4 d-flex flex-column gap-3 mt-4">
                                    {UIHelper.buildStatisticItem(
                                        '#537EC9',
                                        <div className="d-flex align-items-center gap-2">
                                            Thời gian trung bình một công việc
                                        </div>,
                                        '04:50:30',
                                        null,
                                        'fa-solid fa-business-time'
                                    )}
                                    {UIHelper.buildStatisticItem(
                                        '#58B7C6',
                                        <div className="d-flex align-items-center gap-2">
                                            Tổng thu nhập dự kiến{' '}
                                            <KTTooltip
                                                text={`<div><span>Số tiền dự kiến được nhận của kỹ thuật viên từ trước đến nay.</span><br />
                                                    <span>• Thu nhập đã nhận: ${Utils.formatNumber(
                                                    _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0
                                                )} VNĐ</span><br /><span>• Thu nhập chưa nhận: ${Utils.formatNumber(
                                                    _.first(revenueSummary?.operatorEnergyRevenue)?.totalAmount ?? 0
                                                )} VNĐ</span></div>`}
                                                textHeader="Tổng thu nhập dự kiến"
                                                isHtmlContent
                                            >
                                                <i
                                                    className="fa-regular fa-info-circle"
                                                    style={{ color: AppColors.primary }}
                                                />
                                            </KTTooltip>
                                        </div>,
                                        `${Utils.formatNumber(
                                            _.sum([
                                                _.first(revenueSummary?.groupEnergyRevenue)?.totalAmount ?? 0,
                                                _.first(revenueSummary?.investorEnergyRevenue)?.totalAmount ?? 0,
                                                _.first(revenueSummary?.operatorEnergyRevenue)?.totalAmount ?? 0
                                            ])
                                        )} VNĐ`,
                                        AppResource.icons.icExpectedRevenue,
                                        null
                                    )}
                                    {UIHelper.buildStatisticItem(
                                        '#30BD6F',
                                        <div className="d-flex align-items-center gap-2">
                                            Số công việc hoàn thành trong tháng
                                        </div>,
                                        '6',
                                        null,
                                        'fa-solid fa-list-check'
                                    )}
                                </div>
                            </div>
                        </div>,
                        false
                    )}
                </div>
                {/* tong so cong viec da nhan */}
                <div className="col-lg-6 mb-4 px-2">
                    {UIHelper.buildCard(
                        <div>
                            {UIHelper.buildCardHeader('Tổng số công việc đã nhận', false, null, false, true)}
                            <div className="px-4 pb-4 d-flex align-items-center gap-3">
                                <div
                                    className=""
                                    style={{
                                        height: '200px',
                                        width: '200px',
                                    }}
                                >
                                    <DoughnutChartJS
                                        showTitle={false}
                                        showLegend={false}
                                        labels={[
                                            'Bảo trì',
                                            'Sửa chữa',
                                        ]}
                                        datasets={[
                                            {
                                                data: [
                                                    agencyStatistic[AgencyConstants.AgencyRole.SALE] ?? 0,
                                                    agencyStatistic[AgencyConstants.AgencyRole.GROUP] ?? 0,
                                                ],
                                                borderColor: [
                                                    'rgba(255, 255, 255, 1)',
                                                    'rgba(255, 255, 255, 1)',
                                                ],
                                                backgroundColor: [
                                                    'rgba(111, 85, 249, 1)',
                                                    'rgba(248, 151, 47, 1)',
                                                ],
                                                borderWidth: 3,
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="flex-fill">
                                    {UIHelper.buildDoughnutChartLegend([
                                        {
                                            title: 'Bảo trì',
                                            color: 'rgba(111, 85, 249, 1)',
                                            value: agencyStatistic[AgencyConstants.AgencyRole.SALE] ?? 0,
                                        },
                                        {
                                            title: 'Sửa chữa',
                                            color: 'rgba(248, 151, 47, 1)',
                                            value: agencyStatistic[AgencyConstants.AgencyRole.GROUP] ?? 0,
                                        },
                                        {
                                            title: 'Tổng số:',
                                            value: _.sum(_.values(agencyStatistic)),
                                        },
                                    ])}
                                </div>
                            </div>
                        </div>,
                        false,
                        false,
                        true,
                        true
                    )}
                </div>
            </div>

            {/* OLD */}
            {/* <div className="px-4">
        {UIHelper.buildCard(
          <div className="row m-0 p-0">
            <div className="col-lg-4 p-0">
              <div
                className="d-flex flex-column p-4"
                style={{
                  borderBottom: `1px solid ${AppColors.gray[200]}`,
                }}
              >
                <span style={UIHelper.buildFontStyle('700', '30px', AppColors.gray[600])}>
                  {user?.fullname}
                </span>
                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                  {ChargeHelper.Utils.getUserRoleName(user?.role)}
                </span>
              </div>

              <div className="d-flex flex-column gap-3 pt-4 pb-6">
                <div className="px-4 pt-3">
                  <CircleChart
                    title="Trạng thái trụ sạc"
                    total={chargePointStatistic.total}
                    value={chargePointStatistic.charging}
                    color="rgba(44, 143, 241, 1)"
                    valueText="Đang sạc"
                    remainText="Đang nghỉ"
                  />
                </div>

                <div className="px-4 pb-5">
                  <CircleChart
                    title="Trạng thái kết nối trụ sạc"
                    total={chargePointStatistic.total}
                    value={chargePointStatistic.connected}
                    color="rgba(36, 202, 73, 1)"
                    valueText="Đang kết nối"
                    remainText="Mất kết nối"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-8 p-0">
              <CustomCarousel
                images={[
                  { src: AppResource.images.evg.imgSlide1, alt: 'Image 1' },
                  { src: AppResource.images.evg.imgSlide2, alt: 'Image 2' },
                  { src: AppResource.images.evg.imgSlide3, alt: 'Image 3' },
                ]}
                interval={5000}
              />
            </div>
          </div>
        )}
      </div> */}

            {/* thong ke */}
            <div className="">
                <div className="px-4">
                    {UIHelper.buildCard(
                        <div className="">
                            <div className="row m-0 p-0 px-2 pt-4">
                                {/* cong suat tuc thi he thong */}
                                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                                    {UIHelper.buildStatisticItem(
                                        'rgba(0, 199, 190, 1)',
                                        'Công suất tức thì của hệ thống',
                                        `${Utils.isValid(systemStatistic?.totalPower)
                                            ? Utils.formatNumber((systemStatistic?.totalPower / 1000).toFixed(3))
                                            : 0
                                        } kW`,
                                        AppResource.icons.icTotalPower
                                    )}
                                </div>
                                {/* san luong dien trong ngay */}
                                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                                    {UIHelper.buildStatisticItem(
                                        'rgba(83, 159, 248, 1)',
                                        'Tổng sản lượng điện trong ngày',
                                        `${Utils.isValid(systemStatistic?.totalEnergy)
                                            ? Utils.formatNumber((systemStatistic?.totalEnergy / 1000).toFixed(3))
                                            : 0
                                        } kWh`,
                                        AppResource.icons.icTotalEnergy
                                    )}
                                </div>
                                {/* so phien sac trong ngay */}
                                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                                    {UIHelper.buildStatisticItem(
                                        'rgba(120, 118, 229, 1)',
                                        'Tổng số phiên sạc trong ngày',
                                        `${Utils.isValid(systemStatistic?.totalTransactions)
                                            ? Utils.formatNumber(systemStatistic?.totalTransactions)
                                            : 0
                                        } phiên`,
                                        AppResource.icons.icTotalTransactions
                                    )}
                                </div>
                                {/* tong thoi gian sac trong ngay */}
                                <div className="col-xl-3 col-lg-6 mb-4 px-2">
                                    {UIHelper.buildStatisticItem(
                                        'rgba(122, 214, 97, 1)',
                                        'Tổng thời gian sạc trong ngày',
                                        Utils.isValid(systemStatistic?.totalChargeDuration)
                                            ? Utils.convertSecondsToHText(systemStatistic?.totalChargeDuration)
                                            : '',
                                        AppResource.icons.icTotalDuration
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* bieu do */}
            <div className="mt-4">
                <div className="row m-0 p-0 px-2">
                    {/* thong ke dien sac */}
                    <div className="col-lg-6 px-2 mb-4">{chartEnergyByDateEl}</div>
                    {/* thong ke phien sac */}
                    <div className="col-lg-6 px-2 mb-4">{chartTransactionByDateEl}</div>
                    {/* thong ke doanh thu ban dien*/}
                    <div className="col-lg-6 px-2 mb-4">{chartEnergyRevenueByDateEl}</div>
                    {/* thong ke doanh thu ban hang*/}
                    <div className="col-lg-6 px-2 mb-4">{chartRevenueByDateEl}</div>
                    {/* thong ke khach hang nap tien */}
                    <div className="col-lg-6 px-2 mb-4">{chartTopupByDateEl}</div>
                    {/* thong ke khach hang */}
                    <div className="col-lg-6 px-2 mb-4">{chartNewUsersByDateEl}</div>
                    {/* thong ke khach hang moi */}
                    {/* <div className="col-lg-6 px-2 mb-4">{chartNewUsersByDateEl}</div> */}
                    {/* thong ke trang thai tru sac */}
                    <div className="col-lg-6 px-2 mb-4">
                        {UIHelper.buildCard(
                            <div>
                                {UIHelper.buildCardHeader(
                                    'Thống kê trạng thái trụ sạc',
                                    false,
                                    filterChargeStationEl,
                                    false,
                                    true
                                )}
                                <div className="px-4 pb-4 d-flex align-items-center gap-3">
                                    <div
                                        className=""
                                        style={{
                                            height: '200px',
                                            width: '200px',
                                        }}
                                    >
                                        <DoughnutChartJS
                                            showTitle={false}
                                            showLegend={false}
                                            labels={['Sẵn sàng', 'Đang bận', 'Đang bảo trì', 'Trụ lỗi', 'Mất kết nối']}
                                            datasets={[
                                                {
                                                    data: [
                                                        chargePointSummary[ChargeConstants.ChargePointStatus.AVAILABLE] ?? 0,
                                                        chargePointSummary[ChargeConstants.ChargePointStatus.BUSY] ?? 0,
                                                        chargePointSummary[ChargeConstants.ChargePointStatus.MAINTAINING] ?? 0,
                                                        chargePointSummary[ChargeConstants.ChargePointStatus.FAULT] ?? 0,
                                                        chargePointSummary[ChargeConstants.ChargePointStatus.DISCONNECTED] ?? 0,
                                                    ],
                                                    borderColor: [
                                                        'rgba(255, 255, 255, 1)',
                                                        'rgba(255, 255, 255, 1)',
                                                        'rgba(255, 255, 255, 1)',
                                                        'rgba(255, 255, 255, 1)',
                                                        'rgba(255, 255, 255, 1)',
                                                    ],
                                                    backgroundColor: [
                                                        'rgba(48, 189, 111, 1)',
                                                        'rgba(126, 130, 153, 1)',
                                                        'rgba(255, 157, 28, 1)',
                                                        'rgba(225, 78, 84, 1)',
                                                        'rgba(189, 48, 50, 1)',
                                                    ],
                                                    borderWidth: 3,
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="flex-fill">
                                        {UIHelper.buildDoughnutChartLegend([
                                            {
                                                title: 'Sẵn sàng',
                                                color: 'rgba(48, 189, 111, 1)',
                                                value: chargePointSummary[ChargeConstants.ChargePointStatus.AVAILABLE] ?? 0,
                                            },
                                            {
                                                title: 'Đang bận',
                                                color: 'rgba(126, 130, 153, 1)',
                                                value: chargePointSummary[ChargeConstants.ChargePointStatus.BUSY] ?? 0,
                                            },
                                            {
                                                title: 'Đang bảo trì',
                                                color: 'rgba(255, 157, 28, 1)',
                                                value:
                                                    chargePointSummary[ChargeConstants.ChargePointStatus.MAINTAINING] ?? 0,
                                            },
                                            {
                                                title: 'Trụ lỗi',
                                                color: 'rgba(225, 78, 84, 1)',
                                                value: chargePointSummary[ChargeConstants.ChargePointStatus.FAULT] ?? 0,
                                            },
                                            {
                                                title: 'Mất kết nối',
                                                color: 'rgba(189, 48, 50, 1)',
                                                value:
                                                    chargePointSummary[ChargeConstants.ChargePointStatus.DISCONNECTED] ?? 0,
                                            },
                                            {
                                                title: 'Tổng số:',
                                                value: _.sum(_.values(chargePointSummary)),
                                            },
                                        ])}
                                    </div>
                                </div>
                            </div>,
                            false,
                            false,
                            true,
                            true
                        )}
                    </div>
                    {/* thong bao */}
                    <div className="col-lg-6 px-2 mb-4">
                        {UIHelper.buildCard(
                            <div>
                                {UIHelper.buildCardHeader(
                                    'Thông báo',
                                    false,
                                    null,
                                    false,
                                    true,
                                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[800])}>
                                        Tổng:{' '}
                                        <span style={{ color: AppColors.primary }}>
                                            {Utils.formatNumber(totalSystemLog)} thông báo
                                        </span>
                                    </span>
                                )}
                                <div className="px-4 mb-4">
                                    {UIHelper.buildCard(
                                        <div
                                            className=""
                                            style={{
                                                maxHeight: '200px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            {systemLogList?.map((item, index) => {
                                                return (
                                                    <div key={item?.messageId ?? index}>
                                                        {UIHelper.buildCellSystemInfo(
                                                            <i
                                                                className={`${ChargeHelper.Utils.getMessageLogTypeIcon(
                                                                    item?.level
                                                                )} text-${ChargeHelper.Utils.getMessageLogTypeColor(item?.level)}`}
                                                                style={{
                                                                    fontSize: '22px',
                                                                }}
                                                            />,
                                                            item?.title,
                                                            Utils.formatDateTimeToString(item?.createdAt, 'DD/MM/YYYY - HH:mm'),
                                                            true,
                                                            () => { }
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>,
                                        false,
                                        false,
                                        false
                                    )}
                                </div>
                            </div>,
                            false
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MaintainerDashboardView;
